import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f3ed9e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mt-3" }, "Detail užívateľa")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "form-group mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "first-name" }, "Meno", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Meno nesmie byť prázdne. ", -1))
const _hoisted_8 = { class: "form-group mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "last-name" }, "Priezvisko", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Priezvisko nesmie byť prázdne. ", -1))
const _hoisted_11 = { class: "form-group mb-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "company" }, "Spoločnosť", -1))
const _hoisted_13 = { class: "form-group mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-mail", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " E-mail musí byť správny. ", -1))
const _hoisted_16 = { class: "form-group mb-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Mobil", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Mobil musí začínať s '+421'. ", -1))
const _hoisted_19 = { class: "form-group mb-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "passwd" }, "Heslo", -1))
const _hoisted_21 = ["required"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Heslo nesmie byť prázdne. ", -1))
const _hoisted_23 = { class: "form-group mb-3" }
const _hoisted_24 = {
  key: 0,
  for: "repasswd"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Heslo znovu nesmie byť prázdne. ", -1))
const _hoisted_26 = {
  class: "field flex align-items-center justify-content-between mb-3",
  style: {}
}
const _hoisted_27 = { class: "w-5 grid" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "rola",
  class: "col-12 p-0 pl-2 mt-1 md:col-2 md:mb-0 md:p-2"
}, "Rola", -1))
const _hoisted_29 = { class: "col-12 p-0 pl-2 md:col-10 md:p-2" }
const _hoisted_30 = {
  key: 0,
  class: ""
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "w-5 grid" }
const _hoisted_34 = {
  key: 0,
  for: "color",
  class: "col-12 p-0 pl-2 mt-1 md:col-3 md:mb-0 md:p-2"
}
const _hoisted_35 = {
  key: 1,
  class: "col-2 p-0 pl-2 md:col-2 md:p-2"
}
const _hoisted_36 = { class: "mt-2 float-start" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "Uložiť",
  class: "btn btn-primary me-2"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_form_tag = _resolveComponent("form-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_form_tag, {
        onUserEditEvent: $options.submitHandler,
        name: "userForm",
        event: "userEditEvent"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.user.firstName) = $event)),
              type: "text",
              required: "",
              label: "Meno",
              class: "form-control",
              id: "first-name"
            }, null, 512), [
              [_vModelText, $data.user.firstName]
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.user.lastName) = $event)),
              type: "text",
              required: "",
              label: "Priezvisko",
              class: "form-control",
              id: "last-name"
            }, null, 512), [
              [_vModelText, $data.user.lastName]
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.user.company) = $event)),
              type: "text",
              class: "form-control",
              label: "Spoločnosť",
              id: "company"
            }, null, 512), [
              [_vModelText, $data.user.company]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.user.email) = $event)),
              type: "email",
              required: "",
              class: "form-control",
              id: "email"
            }, null, 512), [
              [_vModelText, $data.user.email]
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", {'is-invalid': !$data.isPhoneValid && $data.isSubmitted}]),
              id: "phone",
              required: "",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.user.phone) = $event))
            }, null, 2), [
              [_vModelText, $data.user.phone]
            ]),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.user.passwd) = $event)),
              type: "text",
              required: $data.user.id === 0,
              label: "Heslo",
              class: "form-control",
              id: "passwd"
            }, null, 8, _hoisted_21), [
              [_vModelText, $data.user.passwd]
            ]),
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            ($data.user.id===0)
              ? (_openBlock(), _createElementBlock("label", _hoisted_24, "Heslo znovu"))
              : _createCommentVNode("", true),
            ($data.user.id===0)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.user.repasswd) = $event)),
                  type: "text",
                  required: "",
                  label: "Heslo znovu",
                  class: "form-control",
                  id: "repasswd"
                }, null, 512)), [
                  [_vModelText, $data.user.repasswd]
                ])
              : _createCommentVNode("", true),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_PrimevueSelect, {
                  id: "rola",
                  modelValue: $data.selectedRole,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.selectedRole) = $event)),
                  options: $data.roles,
                  optionLabel: "name",
                  placeholder: "Vyber rolu",
                  class: "w-full",
                  onChange: $options.handleAdminChange
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value.id != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              ($data.selectedRole.id === 2)
                ? (_openBlock(), _createElementBlock("label", _hoisted_34, "Farba"))
                : _createCommentVNode("", true),
              ($data.selectedRole.id === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createVNode(_component_ColorPicker, {
                      id: "color",
                      modelValue: $data.user.color,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.user.color) = $event)),
                      format: 'hex'
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createVNode(_component_router_link, {
              to: "/admin/users",
              class: "btn btn-outline-secondary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Zrušiť")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["onUserEditEvent"])
    ])
  ]))
}